
import { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import mMap from '@/components/molecules/Map.vue';
import { MAX_BOUNDS } from '@/constants/search.const';
import { EventBus } from '@/functions/eventBus';
import Query, { Param } from '@/functions/query';
import { QueryNames } from '@/enums/querynames.enum';

export interface Texts {
    close: string;
    drawArea: string;
    helpText: string;
    noResults: string;
    removeArea: string;
}

interface Data {
    initial: boolean;
    isDesktop: boolean;
    maxBounds: { lat: number; lng: number }[];
    userLocationIsChecked: boolean;
}

export default {
    components: {
        mMap,
    },

    props: {
        texts: {
            type: Object as PropType<Texts>,
            default: () => ({
                close: '',
                drawArea: '',
                helpText: '',
                noResults: '',
                removeArea: '',
            }),
        },
    },

    data(): Data {
        return {
            initial: true,
            isDesktop: EventBus.isDesktop,
            maxBounds: MAX_BOUNDS,
            userLocationIsChecked: false,
        };
    },

    computed: {
        ...mapGetters({
            brokers: 'brokerSearch/results',
            activeBroker: 'brokerSearch/activeBroker',
            isLoading: 'brokerSearch/isLoading',
            query: 'brokerSearch/query',
        }),
    },

    beforeMount(): void {
        EventBus.$on('app.resize', () => {
            this.isDesktop = EventBus.isDesktop;
        });
    },

    mounted(): void {
        this.loadSearch();
    },

    beforeUnmount(): void {
        EventBus.$off('app.resize');
    },

    methods: {
        ...mapActions({
            setQuery: 'brokerSearch/setQuery',
            setActiveBroker: 'brokerSearch/setActiveBroker',
            setMapHasInteraction: 'search/setMapHasInteraction',
            fetchResults: 'brokerSearch/fetchResults',
        }),

        /**
         * Handle "move" event on map.
         *
         * @param {any} event
         * @return {void}
         */
        onMove(payload: any): void {
            this.setMapHasInteraction(payload.isUserInteraction);
        },

        loadSearch(): void {
            let params = Query.getAll();
            if (!params.length) {
                this.fetchResults();
                
                return;
            }
            
            params.forEach((param: Param) => {
                if (
                    typeof param.value === 'string'
                    && param.key === QueryNames.query
                ) {
                    this.setQuery(param.value);
                }
            });
        },
    },
};
